import { Component } from '@angular/core';

@Component({
  selector: 'app-funfacts-style-one',
  standalone: false,
  templateUrl: './funfacts-style-one.component.html',
  styleUrl: './funfacts-style-one.component.scss'
})
export class FunfactsStyleOneComponent {

}
